// src/lib/deviceIdentity.js

const DEVICE_ID_KEY = "spaceos_device_id_v1";

const createRandomId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  const random = Math.random().toString(36).slice(2);
  const time = Date.now().toString(36);

  return `dev_${time}_${random}`;
};

export const getOrCreateDeviceId = () => {
  try {
    const existing = window.localStorage.getItem(DEVICE_ID_KEY);

    if (existing) {
      return existing;
    }

    const deviceId = createRandomId();
    window.localStorage.setItem(DEVICE_ID_KEY, deviceId);

    return deviceId;
  } catch (error) {
    console.warn("[deviceIdentity] localStorage unavailable", error);

    return createRandomId();
  }
};

export const getDeviceLabel = () => {
  const ua = window.navigator?.userAgent || "";

  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);
  const isMac = /Macintosh|Mac OS X/i.test(ua);
  const isWindows = /Windows/i.test(ua);

  const browser =
    /CriOS|Chrome/i.test(ua)
      ? "Chrome"
      : /Safari/i.test(ua)
        ? "Safari"
        : /Firefox/i.test(ua)
          ? "Firefox"
          : /Edg/i.test(ua)
            ? "Edge"
            : "Browser";

  const os =
    isIOS
      ? "iPhone / iPad"
      : isAndroid
        ? "Android"
        : isMac
          ? "Mac"
          : isWindows
            ? "Windows"
            : "Device";

  return `${os} ${browser}`;
};

export const clearDeviceIdForDebug = () => {
  try {
    window.localStorage.removeItem(DEVICE_ID_KEY);
  } catch (error) {
    console.warn("[deviceIdentity] clear failed", error);
  }
};